import { useQuery } from '@tanstack/react-query';

/**
 * The current organization's plan. The endpoint takes no organization id — the
 * backend resolves it from the token — so the key carries no org scope. That is
 * safe because AuthContext clears the whole query cache on logout.
 *
 * Invalidated after any vehicle create/delete (see useVehicleMutations), since
 * vehicleCount is computed server-side.
 */
export function useMyPlanQuery(api, authToken) {
  return useQuery({
    queryKey: ['myPlan'],
    queryFn: () => api.subscriptions.getMyPlan(authToken),
    enabled: Boolean(api && authToken),
  });
}
